import OurProjectVerticalForm from "../../our-project-vertical/Form";
import { useCorporateDesignProjects } from "../../useHook";

const OurProjectCorporateEdit = () => {
  return (
    <OurProjectVerticalForm
      isEditMode={true}
      useProjectsHook={useCorporateDesignProjects}
      listPath="/our-project-corporate-design"
      subtitle="Corporate construction project"
    />
  );
};

export default OurProjectCorporateEdit;
